<template>
    <div class="form-select">
        <div class="form-select__input">
            <input
                @click="open = !open"
                readonly
                type="text"
                :value="value"
            />
            <div
                class="form-select__placeholder"
                v-if="!value"
            >
                {{ placeholder }}
            </div>
        </div>
        <div class="form-select__dropdown" v-if="open">
            <div class="form-select__dropdown-wrapper">
                <div
                    class='form-select__dropdown-item'
                    :key="index"
                    @click="chooseVal(val)"
                    v-for="(val, index) in dataArray"
                >
                    {{ val }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSelect',
    props: {
        value: {
            type: String
        },
        disabled: {type: Boolean, default: false},
        dataArray: {
            type: Array
        },
        placeholder: {
            type: String,
            default: null
        },
    },
    model: {
        prop: 'valueLocal',
        event: 'change'
    },
    data: () => ({
        searchQuery: null,
        open: false,
    }),
    methods: {
        chooseVal(value) {
            this.open = false;
            this.$emit('change', value);
        }
    },
    mounted() {
        this.valueLocal = this.dataArray.length ? this.dataArray[0] : '';
    },
};
</script>
<style lang="scss" scoped>
@import "../../scss/base/include";

$b: '.form-select';

#{$b} {
    height: 100%;
    width: 100%;

    &__input {
		position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        input {
            cursor: pointer;
            border: 1px solid #EAEAEA;
            padding: 22px 12px;
            position: relative;
            background: right 10px center url('/local/templates/pnd/src/assets/i2/dropdown.svg') no-repeat;
            border-radius: 5px;
            width: 100%;
        }
    }

    &__dropdown {
		position: absolute;
		max-height: 340px;
		width: 100%;
		display: flex;
		left: 0;
		padding: 20px 0;
		margin-top: 17px;
        background-color: $white-true;
        border: 1px solid rgba(125, 121, 135, 0.2);
        border-radius: 5px;
        z-index: 10;
        box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
		overflow-y: auto;

        &::before {
            content: '';
            position: absolute;
            width: 17px;
            height: 17px;
            border-top: 1px solid rgba(125, 121, 135, 0.2);
            border-left: 1px solid rgba(125, 121, 135, 0.2);
            transform: rotate(45deg);
            background-color: $white-true;
            top: -10px;
            left: 22px;
        }

        &-wrapper {
            overflow: auto;
            width: 100%;
        }

        &-item {
            padding: 10px 20px;
            font-size: 16px;
            line-height: 18px;
            cursor: pointer;

            &:hover {
                color: $accent;
            }

            &._disabled {
                color: rgba(125, 121, 135, 0.4);
                background-color: #EAEAEA;
                pointer-events: none;
            }
        }
    }

    &__placeholder {
        position: absolute;
        color: rgba(125, 121, 135, .8);
        pointer-events: none;
        left: 12px;
		top: 48%;
		transform: translateY(-50%);
    }
}
</style>